import React, { Component } from "react";
import { NavLink, Redirect, withRouter, RouteComponentProps } from "react-router-dom";
import UserIcon from "@material-ui/icons/PersonOutlined";
import clsx from "clsx";
import { withAuth, IAuthProps } from "../../../laco-common/auth/AuthContext";
import UIMenuBtn, { IMenuOption } from "../../ui/UIMenuBtn";
import NotificationsService from "../../../laco-common/services/notifications";
import { PSRole, getPSRole } from "../../../models/peer-support";
import ClientFirebase from "../../../laco-common/firebase/web";
import "./AuthSignIn.scss";

export type AuthSignInProps = {
	hideDonate?: boolean;
	lightMode?: boolean;
	btnRegMode?: boolean;
};

type AuthSignInState = {
	menuOptions: IMenuOption[];
	redirectToLogin: boolean;
};

class AuthSignIn extends Component<IAuthProps & RouteComponentProps & AuthSignInProps, AuthSignInState> {
	state = {
		menuOptions: [],
		redirectToLogin: false,
	};

	componentDidMount() {
		if (this.props.authContext.loading || !this.props.authContext.isAuthenticated) return;
		const adminOptions: IMenuOption[] =
			this.props.authContext.userPayload.superAdmin || this.props.authContext.userPayload.profile.cmsRoles?.length
				? [
						{ optionType: "separator" },
						{ optionType: "heading", title: "Management" },
						{ title: "Admin", onClick: () => this.navigate("/admin") },
						{ title: "Form Submissions", onClick: () => this.navigate("/form-submissions") },
						// { title: "House Fund", onClick: () => this.navigate("/admin/house-fund") },
				  ]
				: [
						{ optionType: "separator" },
						{ optionType: "heading", title: "Activity" },
						{ title: "Form Submissions", onClick: () => this.navigate("/form-submissions") },
				  ];
		const psRole: PSRole = getPSRole(this.props.authContext, ClientFirebase);
		let psOptions: IMenuOption[] = [];
		if (psRole !== "guest") {
			psOptions = [
				{ optionType: "separator" },
				{ optionType: "heading", title: "Resources" },
				{ title: "Peer Support", onClick: () => this.navigate("/ps") },
			];
		}
		const options: IMenuOption[] = [
			...adminOptions,
			...psOptions,
			{ optionType: "separator" },
			{ optionType: "heading", title: "Account" },
			{ title: "Profile", onClick: () => this.navigate("/user/profile") },
			{ title: "Logout", onClick: () => this.logout() },
		];
		this.setState({ menuOptions: options });
	}

	login() {
		console.log("login");
		this.setState({ redirectToLogin: true });
	}

	logout() {
		console.log("logout");
		this.props.authContext.logout();
		this.props.history.push(this.props.location.pathname);
		NotificationsService.info("Logged Out");
		return Promise.resolve();
	}

	navigate(path: string) {
		this.props.history.push(path);
		return Promise.resolve();
	}

	renderUser() {
		return (
			<div className="auth-signin d-flex align-items-center">
				<UIMenuBtn
					menuId="login-menu"
					btnVariant="outlined"
					menuClassName={clsx(this.props.lightMode && "light-mode", "ui-menu-btn-popover")}
					btnClassName={clsx(this.props.lightMode && !this.props.btnRegMode && "btn-light-outline")}
					title={
						<>
							{/*<UserImageIcon userPayload={xthis.props.authContext.userPayload} />*/}
							<UserIcon style={{ fontSize: "1.05rem", marginRight: "8px" }} />
							<span className="ui-text-overflow" style={{ maxWidth: "22vw" }}>
								{this.props.authContext.userPayload.profile.first_name}
							</span>
						</>
					}
					options={this.state.menuOptions}
				>
					<li className="my-2">{this.props.authContext.userPayload.displayName}</li>
					<li className="mb-2">{this.props.authContext.userPayload.email}</li>
				</UIMenuBtn>
			</div>
		);
	}

	renderLogin() {
		return (
			<div className="auth-signin auth-login d-inline-flex flex-wrap flex-shrink-1 align-items-center justify-content-end">
				{!this.props.hideDonate && !process.env.REACT_APP_HIDE_DONATE && (
					<NavLink className="d-none d-xl-inline-block" to={"/donate"}>
						<button className="btn btn-primary">Donate</button>
					</NavLink>
				)}
				<button
					className={clsx(
						"d-none d-xl-inline-block btn",
						this.props.lightMode ? "btn-light-outline" : "btn-default"
					)}
					onClick={() => this.login()}
				>
					Member Login
				</button>
			</div>
		);
	}

	render() {
		if (this.state.redirectToLogin)
			return <Redirect to={{ pathname: "/login", state: { redirectedFrom: this.props.location } }} />;

		if (this.props.authContext.loading) {
			return <div style={{ width: "80px" }}></div>;
		} else if (this.props.authContext.isAuthenticated) {
			return this.renderUser();
		} else {
			return this.renderLogin();
		}
	}
}

export default withAuth(withRouter(AuthSignIn), true);
